import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import "./styles/index.css";

import AppRouter from "./app/AppRouter";
import { ThemeProvider, useTheme } from "./features/theme";
import { publishVersionGlobal } from "./lib/version";

// Some tasty providers
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";

import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Expose the build identity on window before anything else can fail, so a
// broken deployment can still be identified from the console (issue #1354).
publishVersionGlobal();

// Configure Amplify once with all necessary options
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: "6cllmb6g0fsavvsgf3ak8po3gt",
      userPoolId: "us-east-1_ja6W0NI9c",
    },
  },
});

// Toasts render outside the app tree, so give them their own theme consumer.
function ThemedToastContainer() {
  const { resolvedTheme } = useTheme();
  return (
    <ToastContainer
      position="top-center"
      autoClose={2000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Slide}
      theme={resolvedTheme}
    />
  );
}

const rootElement = document.getElementById("root");

// Sentry.init({
//   dsn: "https://10322987fb6e39700eeb8f5796a8de07@o4505754991591424.ingest.us.sentry.io/4510364401926144",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true
// });


if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <ThemedToastContainer />
        <AppRouter />
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}
